import React, { useState } from "react";
import { Image, Message, ImageProps, Button, Icon, Modal } from "semantic-ui-react";
import { useFileUploadService } from "../context/FileUploadServiceContext";
import useFileToken from "../hooks/useFileToken";
import { isLoaded, isLoadErrored, TLoadable, createLoaded } from "../../sg-core/models/ILoadable";
import * as Endpoint from "../../endpoints";
import { getFileUrl, getThumbnailUrl } from "../utils/image.helpets";
import { makeSuccess, TResult } from "../../sg-core/utils/Result";

const PUBLIC_PATH = process.env.PUBLIC_URL


const LARGE_IMAGE_STYLE = {
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
    width: "auto",
    height: "auto",
}

const MODAL_CONTENT_STYLE = {
    minHeight: "500px",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden"
}

const LOAD_ERRORED_STYLE = {
    height: 90,
    width: 120,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.1)'
}


interface IImageProps extends ImageProps {
    id: string;
    thumbnailWidth?: number;
    thumbnailHeight?: number
}


const Thumbnail: React.FC<IImageProps> = ({ id, thumbnailWidth, thumbnailHeight, ...imgProps }) => {
    const fileService = useFileUploadService();
    if (!fileService) { throw new Error("ImageView cannot exists without an SG fileupload context.") };

    const [imageFailed] = useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);


    const fileToken = createLoaded("434") as TLoadable<string> //    useFileToken();


    if (imageFailed) {
        return (
            <a className={imgProps.className} style={LOAD_ERRORED_STYLE}>
                <Icon name="ban" size="large" color="grey" />
            </a>)
    }


    if (isLoaded(fileToken)) {
        const fileUrl = getFileUrl(
            Endpoint.Upload6.path,
            id,
            fileToken.data
        );
        const thumbnailUrl = getThumbnailUrl(
            Endpoint.Upload6.path,
            id,
            fileToken.data,
            thumbnailHeight,
            thumbnailWidth
        );
        return (
            <Modal
                open={isModalOpen}
                trigger={<Image {...imgProps} src={thumbnailUrl} />}
                onOpen={openModal}
                onClose={closeModal}
            >
                <Modal.Content style={MODAL_CONTENT_STYLE}>
                    <div>
                        <Image
                            src={fileUrl}
                            alt={id}
                            style={LARGE_IMAGE_STYLE}
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions >
                    <Button onClick={closeModal} negative style={{ width: "100%", marginLeft: 0 }}> Sulje </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    if (isLoadErrored(fileToken)) {
        //   return <Message negative compact>Kuvan lataus ei onnistunut</Message>;
    }

    return <Image
        {...imgProps}
        src={PUBLIC_PATH + "/loading_placeholder.gif"}
        style={{ maxHeight: "100px" }}
    />;

};

export default Thumbnail;
